import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pricing from "@/pages/Pricing";
import MembershipSuccess from "@/pages/MembershipSuccess";
import Feed from "@/pages/Feed";
import UploadPage from "@/pages/Upload";
import VideoDetail from "@/pages/VideoDetail";
import CoachDashboard from "@/pages/CoachDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Lesson from "@/pages/Lesson";
import LessonSuccess from "@/pages/LessonSuccess";
import Profile from "@/pages/Profile";
import MySwings from "@/pages/MySwings";

function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/5 py-12 px-6 text-center">
      <div className="overline">Dr. Cuts · Members Studio</div>
      <p className="text-white/40 text-xs mt-4">© {new Date().getFullYear()} Dr. Cuts. Bend it like physics intended.</p>
    </footer>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Nav />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/membership/success" element={<MembershipSuccess />} />
            <Route path="/feed" element={<Feed />} />
            <Route path="/my-swings" element={<MySwings />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/video/:id" element={<VideoDetail />} />
            <Route path="/coach" element={<CoachDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/lesson" element={<Lesson />} />
            <Route path="/lesson/success" element={<LessonSuccess />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
